import React, { useState, useEffect, useRef } from 'react';
// libraries and components
import SVG from "react-inlinesvg";
// assets
import { deleteSVG, phoneSVG } from '../../../shared/helpers/icons';
// styles
import styles from './dialPad.module.scss';

const DialPad = ({handleMakeCall, isCalling, setIsCalling}) => {

    const [phoneToDial, setPhoneToDial] = useState('');

    const numberInput = useRef(null);
    
    const handleAddNumber = (number) => {
        let phone = phoneToDial
        setPhoneToDial(phone += number);
    }
    
    const handleDelete = () => {
        let phone = phoneToDial;
        setPhoneToDial(phone.slice(0, phone.length - 1))
    }

    const handleDialNumber = (e) => {
        setPhoneToDial(e.target.value)
    }

    const handleCall = () => {
        setIsCalling(true);
        handleMakeCall(numberInput.current.value);
    }

    const handleCleanNumber = () => {
        setPhoneToDial('');
    }

    useEffect(() => {
        if(!isCalling){
            setPhoneToDial('');
        }
    }, [isCalling]);

    useEffect(() => {
        if(numberInput){
            const end = numberInput.current.value.length;
            numberInput.current.setSelectionRange(end, end);
            numberInput.current.focus();
        }
    }, [phoneToDial, numberInput]);

    return(
        <div className={styles.noCalling}>
            <div className={styles.phoneDisplay}>
                <input className={styles.numberInput} ref={numberInput} onChange={handleDialNumber} value={phoneToDial}/>
            </div>
            <div className={styles.numberRow}>
                <button onClick={event => handleAddNumber("1")}>1</button>
                <button onClick={event => handleAddNumber("2")}>2</button>
                <button onClick={event => handleAddNumber("3")}>3</button>
            </div>
            <div className={styles.numberRow}>
                <button onClick={event => handleAddNumber("4")}>4</button>
                <button onClick={event => handleAddNumber("5")}>5</button>
                <button onClick={event => handleAddNumber("6")}>6</button>
            </div>
            <div className={styles.numberRow}>
                <button onClick={event => handleAddNumber("7")}>7</button>
                <button onClick={event => handleAddNumber("8")}>8</button>
                <button onClick={event => handleAddNumber("9")}>9</button>
            </div>
            <div className={styles.numberRow}>
                <button onClick={event => handleAddNumber("*")}>*</button>
                <button onClick={event => handleAddNumber("0")}>0</button>
                <button onClick={event => handleAddNumber("#")}>#</button>
            </div> 
            <div className={styles.buttonContainer}>
                <button className={styles.callButton} onClick={handleCall}> 
                    <SVG src={phoneSVG}/>
                </button>
                <button className={styles.deleteNumber} onClick={handleDelete} onDoubleClick={handleCleanNumber}> 
                    <SVG src={deleteSVG}/>
                    <div className={styles.backColor} />
                </button>
            </div>
        </div>
    )

};
export default DialPad;